import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getPrecertificacion: ["payload"],
  getPrecertificacionLoading: null,
  getPrecertificacionSuccess: ["getPrecertificacionData"],
  getPrecertificacionFailure: ["getPrecertificacionError"],

  consultarPrecertificaciones: ["payload"],
  consultarPrecertificacionesLoading: null,
  consultarPrecertificacionesSuccess: ["consultarPrecertificacionesData"],
  consultarPrecertificacionesFailure: ["consultarPrecertificacionesError"],

  confirmarPrecertificacion: ["payload"],
  confirmarPrecertificacionLoading: null,
  confirmarPrecertificacionSuccess: ["confirmarPrecertificacionData"],
  confirmarPrecertificacionFailure: ["confirmarPrecertificacionError"],

  cancelarPrecertificacion: ["payload"],
  cancelarPrecertificacionLoading: null,
  cancelarPrecertificacionSuccess: ["cancelarPrecertificacionData"],
  cancelarPrecertificacionFailure: ["cancelarPrecertificacionError"],

  tiposSolicitudesPrecertificacion: ["payload"],
  tiposSolicitudesPrecertificacionLoading: null,
  tiposSolicitudesPrecertificacionSuccess: [
    "tiposSolicitudesPrecertificacionData"
  ],
  tiposSolicitudesPrecertificacionError: [
    "tiposSolicitudesPrecertificacionError"
  ],

  crearPrecertificacion: ["payload"],
  crearPrecertificacionLoading: null,
  crearPrecertificacionSuccess: ["crearPrecertificacionData"],
  crearPrecertificacionError: ["crearPrecertificacionError"],

  consultarUnaPrecertificacion: ["payload"],
  consultarUnaPrecertificacionLoading: null,
  consultarUnaPrecertificacionSuccess: ["consultarUnaPrecertificacionData"],
  consultarUnaPrecertificacionFailure: ["consultarUnaPrecertificacionError"],

  modificarPrecertificacion: ["payload"],
  modificarPrecertificacionLoading: null,
  modificarPrecertificacionSuccess: ["modificarPrecertificacionData"],
  modificarPrecertificacionError: ["modificarPrecertificacionError"],

  descargarVoucherPrecertificacion: ["payload"],
  descargarVoucherPrecertificacionLoading: null,
  descargarVoucherPrecertificacionSuccess: ["descargarVoucherPrecertificacionData"],
  descargarVoucherPrecertificacionError: ["descargarVoucherPrecertificacionError"]
});

export { Types };

export default Creators;
